"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var instructor_documents_index_module_1 = __importDefault(require("./index/instructor-documents-index.module"));
var instructor_sign_document_module_1 = __importDefault(require("./sign/instructor-sign-document.module"));
function config($stateProvider) {
    $stateProvider.state("drivecoach.instructor.documents", {
        abstract: true,
        url: "/documents",
        template: "<ui-view/>",
    });
}
config.$inject = ["$stateProvider"];
exports.default = angular_1.default
    .module("instructor.documents", [
    instructor_documents_index_module_1.default.name,
    instructor_sign_document_module_1.default.name,
])
    .config(config);
